import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Header from "./components/component/Header";
import RequireQualifica from './components/component/RequireQualifica';
import ScrollToTop from './components/component/ScrollToTop';
import LoginPage from './components/LoginPage';
import OrderDetails from './components/OrderDetails';
import OrderListPage from './components/OrderListPage';
import PickingListPage from './components/PickingListPage';
import useInactivityLogout from './hooks/useInactivityLogout';
import './index.css';

function App() {

  useInactivityLogout();

  return (
    <div className='root'>
      <Header />
      <ScrollToTop>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />
          {/* Sezione produzione: qualifiche 0/1/2 */}
          <Route path="/order-details/:order_uuid" element={<RequireQualifica allowed={[0, 1, 2]}><OrderDetails /></RequireQualifica>} />
          {/* Sezione magazzino alimentare: qualifica 3 = Magazzinieri */}
          <Route path="/orders" element={<RequireQualifica allowed={[3]}><OrderListPage /></RequireQualifica>} />
          <Route path="/orders/:order_uuid" element={<RequireQualifica allowed={[3]}><PickingListPage /></RequireQualifica>} />
        </Routes>
      </ScrollToTop>
      {/* <Footer /> */}
    </div>
  );
}

export default App;
